import { useEffect, useState } from 'react';
import Indicators from './Indicators';
import WealthPackages from './WealthPackages';
import { textWithIcon, fetchData, onCellClicked, styles } from './Helpers'; 
import { fileKeyImg, resolveImage } from "../../images/ImageResolver";

function EventTypes({wealth, setWealth}) { 
  const [fullData, setFullData] = useState([]);
  const [loading, setLoading] = useState(true);

  function transformData(data){
    const rowKeys = ["headLines","details","economics","headLinesEndpoint","detailsEndpoint","economicsEndpoint"]
    const tData = data
      .filter(row => row.eventTypes === "Economic") // change condition as needed
      .map(row => ({
        name: row.eventSubTypes + ',' + row.eventCode,
        public: row.public,
        private: row.private,
        professional: row.professional,
        rowData: rowKeys.map(key => (row[key] ? row[key].replace(/,/g, "") : "")).join(",")
      }))
    return tData
  }

  useEffect(() => {
    fetchData("Event_Types").then(res => {
      setFullData(transformData(res));
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    const grid = document.getElementById('grid');
    if(!wealth){
      grid.addEventListener("click", onCellClicked);
    }
  }, [wealth]);

  useEffect(() => {
    const grid = document.getElementById('grid');
    const columns = [
      { name: 'ITEM', field: 'name', width: 4, scalable: true, binding: cellWithMultipleLines },
      { name: 'PUBLIC', field: 'public', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "Non Professional", "free"), binding: textWithIcon, styles: styles },
      { name: 'PRIVATE', field: 'private', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "Non Professional", "private"), binding: textWithIcon },
      { name: 'INTERNAL PROFESSIONAL', field: 'professional', width: 1.5, scalable: true, headerBinding: headerWithLink.bind(null, "Private", "professional"), binding: textWithIcon, styles: styles }
    ]

    let onRowExpansionBinding = function(e) {
      let rowData = e.originalRowData;
      let data = rowData ? rowData["rowData"].split(',') : [];
      let rowIndex = e["rowIndex"];
      let section = e["section"];
      let cell = section.stretchCell(0, rowIndex, true);
      if (e.rowExpansion && rowData) {
        // render
        cell.setStyle("backgroundColor", "#FFFFF");
        section.setRowHeight(rowIndex, 100); // Customized height

        let expContent = cell.getContent();
        if (!expContent || !expContent._myExpansion) {
          expContent = document.createElement("div");
          expContent._myExpansion = true;

          let firstLine = expContent._firstLine = document.createElement("ef-layout");
          firstLine.style.display = "flex";
          firstLine.style.marginBottom = "10px";
          firstLine.style.paddingLeft = "10px";
          let secondLine = expContent._secondLine = document.createElement("ef-layout");
          secondLine.style.display = "flex";
          secondLine.style.paddingLeft = "10px";
          let thirdLine = expContent._thirdLine = document.createElement("ef-layout");
          thirdLine.style.display = "flex";
          thirdLine.style.paddingLeft = "10px";

          let endpointLabel = document.createElement("label");
          let endpointInput = document.createElement("ef-text-field");
          endpointLabel.textContent = "Headline Endpoint:";
          endpointLabel.style.fontWeight = "600";
          endpointLabel.style.marginRight = "0px";
          endpointLabel.style.color = "#334d6e";
          endpointLabel.style.fontSize = "16px";
          endpointLabel.style.height = "18px";
          endpointLabel.style.width = "150px";
          endpointLabel.style.padding = "8px 20px 14px 20px";
          endpointLabel.style.backgroundColor = "#e8e8e8";
          endpointLabel.style.border = "1px solid #e8e8e8";
          endpointInput.value = data[3];
          endpointInput.style.width = "60%";
          endpointInput.style.padding = "10px 20px";
          endpointInput.readOnly = true;
          endpointInput.style.color = "#334d6e";
          endpointInput.style.fontSize = "14px";
          endpointInput.style.border = "1px solid #e8e8e8";
          endpointInput.style.height = "40px";
          firstLine.appendChild(endpointLabel);
          firstLine.appendChild(endpointInput);

          let endpointLabel2 = document.createElement("label");
          let endpointInput2 = document.createElement("ef-text-field");
          endpointLabel2.textContent = "Details Endpoint:";
          endpointLabel2.style.fontWeight = "600";
          endpointLabel2.style.marginRight = "0px";
          endpointLabel2.style.color = "#334d6e";
          endpointLabel2.style.fontSize = "16px";
          endpointLabel2.style.height = "18px";
          endpointLabel2.style.width = "150px";
          endpointLabel2.style.padding = "8px 20px 14px 20px";
          endpointLabel2.style.backgroundColor = "#e8e8e8";
          endpointLabel2.style.border = "1px solid #e8e8e8";
          endpointInput2.value = data[4];
          endpointInput2.style.width = "60%";
          endpointInput2.style.padding = "10px 20px";
          endpointInput2.readOnly = true;
          endpointInput2.style.color = "#334d6e";
          endpointInput2.style.fontSize = "14px";
          endpointInput2.style.border = "1px solid #e8e8e8";
          endpointInput2.style.height = "40px";
          secondLine.appendChild(endpointLabel2);
          secondLine.appendChild(endpointInput2);

          let endpointLabel3 = document.createElement("label");
          let endpointInput3 = document.createElement("ef-text-field");
          endpointLabel3.textContent = "Economics Endpoint:";
          endpointLabel3.style.fontWeight = "600";
          endpointLabel3.style.marginRight = "0px";
          endpointLabel3.style.color = "#334d6e";
          endpointLabel3.style.fontSize = "16px";
          endpointLabel3.style.height = "18px";
          endpointLabel3.style.width = "150px";
          endpointLabel3.style.padding = "8px 20px 14px 20px";
          endpointLabel3.style.backgroundColor = "#e8e8e8";
          endpointLabel3.style.border = "1px solid #e8e8e8";
          endpointInput3.value = data[5];
          endpointInput3.style.width = "60%";
          endpointInput3.style.padding = "10px 20px";
          endpointInput3.readOnly = true;
          endpointInput3.style.color = "#334d6e";
          endpointInput3.style.fontSize = "14px";
          endpointInput3.style.border = "1px solid #e8e8e8";
          endpointInput3.style.height = "40px";
          thirdLine.appendChild(endpointLabel3);
          thirdLine.appendChild(endpointInput3);

          if(data[0].toLowerCase() === "x"){
            expContent.appendChild(firstLine);
          }
          
          if(data[1].toLowerCase() === "x"){
             expContent.appendChild(secondLine);
          }

          if(data[2].toLowerCase() === "x"){
             expContent.appendChild(thirdLine);
          }
        }

        rowData = e.originalRowData;
        cell.setContent(expContent);
      } else {
        // dispose
        cell = section.stretchCell(0, rowIndex, false);
        cell.setStyle("backgroundColor", "");
        section.setRowHeight(rowIndex, section.getDefaultRowHeight()); // Default height
      }
    };

    function cellWithMultipleLines(e) {
      let cell = e.cell;
      let content = cell.getContent();
      if (!content) {
        let rowData = e.data.split(",");
        content = document.createElement("div");
        // content.style.textAlign = "center";
        content.style.whiteSpace = "pre-line";
        let firstLine = document.createElement("button");
        let firstLineIcon = document.createElement("ef-icon");
        let firstLineText = document.createElement("span");
        firstLineIcon.icon = "right";
        firstLineIcon.style.marginRight = "10px";
        firstLine.style.fontWeight = "600";
        firstLine.style.color = "#0f1e8a";
        firstLine.style.backgroundColor = "transparent";
        firstLine.style.border = "none";
        firstLine.style.margin = "0px";
        firstLine.style.padding = "0px";
        firstLine.style.fontSize = "14px";
        firstLine.style.cursor = "pointer";
        firstLine._firstLineIcon = firstLineIcon;
        firstLine.appendChild(firstLineIcon);
        firstLineText.textContent = rowData[0];
        firstLine.appendChild(firstLineText);
        content._firstLine = firstLine;
        content.appendChild(firstLine);
        content.appendChild(document.createElement("br"));

        let secondLine2 = document.createElement("ef-pill");
        let secondLine22 = document.createElement("span");
        let secondLine2Icon = document.createElement("img");
        secondLine2Icon.src = fileKeyImg;
        secondLine2Icon.style.marginRight = "5px";
        secondLine2Icon.style.marginTop = "5px";
        secondLine22._secondLine2Icon = secondLine2Icon;
        secondLine22.appendChild(secondLine2Icon);
        secondLine2.style.fontWeight = "400";
        secondLine2.style.backgroundColor = "transparent";
        secondLine2.style.color = "#999999";
        secondLine2.style.border = "none";
        secondLine22.textContent = rowData[1];
        secondLine22.style.fontSize = "14px";
        secondLine22.style.display = "inline-flex";
        secondLine22.style.verticalAlign = "super";
        secondLine2.appendChild(secondLine2Icon);
        secondLine2.appendChild(secondLine22);
        content._secondLine2 = secondLine2;
        content.appendChild(secondLine2);

        content.addEventListener("click", function() {
          if (firstLineIcon.icon === "right") {
            firstLineIcon.icon = "down";
          } else {
            firstLineIcon.icon = "right";
          }
        });
      }
      cell.setContent(content);
    }

    function headerWithLink(text, i, e) {
      let cell = e.cell;
      let content = cell.getContent();
      if(!content || !content._myHeaderWithLink) {
        content = document.createElement("div");
        content._myHeaderWithLink = true;
        let span = content._span = document.createElement("span");
        span.style.marginRight = "5px";
        let link = content._link = document.createElement("ef-icon");
        link.icon = "link";
        content.addEventListener("click", function(arg) {
          arg.stopPropagation();
          setWealth(true);
        });
        let image = content._span1 = document.createElement("img");
        image.style.position = "absolute";
        image.style.top = "10px";
        image.style.right = "5px";
        image.style.width = "38px";
        image.src = resolveImage(i);
        let span2 = content._span2 = document.createElement("span");
        span2.style.display = "block";
        span2.style.fontWeight = 400;
        content.appendChild(span);
        content.appendChild(link);
        content.appendChild(span2);
        content.appendChild(image);
      }

      content._span.textContent = e.columnDef.getName();
      content._span2.textContent = text;
      cell.setContent(content);
    };

    if(!wealth){
      grid.config = {
        rowHeight: 90,
        headerRowHeight: 60,
        columns: columns,
        dataModel: {
          data: fullData
        },
        sorting: {
          sortableColumns: false,
          initialSort: {
              colIndex: 0, // Column index
              sortOrder: "a"
          }
      },
      rowExpansionBinding: onRowExpansionBinding
      };
    }
  }, [wealth, setWealth, fullData]);

  return (
    <div>
      <ef-loader class="loader" hidden={!loading}></ef-loader>
      {wealth && (
        <div>
          <ef-button className="back-button" icon="back" onClick={() => setWealth(false)}>Back</ef-button>
          <WealthPackages />
        </div>
      )}
      {!wealth && (
        <ef-layout>
          <ef-layout flex style={{ marginTop: '20px' }}>
            <ef-layout>
              <Indicators toggle={false} />
            </ef-layout>
          </ef-layout>
          <efx-grid id="grid" className="entity-grid"></efx-grid>
        </ef-layout>
      )}
    </div>
  );
}

function EventsCalendar({flag=true}) {
  const [eventData, setEventData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [loading, setLoading] = useState(true);

  function searchEvent(val) {    
    setSearchData(eventData.filter(item => item.searchkey.toLowerCase().includes(val.toLowerCase())));
  }

  useEffect(() => {
    fetchData("Event_ECI_vs_ECIX").then(res => {
      setEventData(res);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    const grid = document.getElementById('grid');
    const columns = [
      { name: 'Indicator Name', field: 'ecixRicName', width: 4, scalable: true },
      { name: 'Country', field: 'ecixCountry', width: 3, scalable: true },
      { name: 'RIC', field: 'ecixRic', width: 3, scalable: true },
      { name: 'Country', field: 'eciCountry', width: 3, scalable: true },
      { name: 'RIC', field: 'eciRic', width: 3, scalable: true }
    ]
    columns.forEach((col,i) => {
      if(i === 0){
        return;
      }else if(i<3){
        col.visible = flag;
      }else{
        col.visible = !flag;
      }
    });
    grid.config = {
      rowHeight: 60,
      headerRowHeight: 50,
      columns: columns,
      dataModel: {
        data: searchData.length > 0 ? searchData : eventData
      },
      sorting: {
        sortableColumns: false,
        initialSort: {
            colIndex: 0, // Column index
            sortOrder: "a"
        }
      }
    };
  }, [eventData, searchData, flag]);

  return (
    <div>
      <ef-loader class="loader" hidden={!loading}></ef-loader>
        <ef-layout flex style={{ marginTop: '20px' }}>
        <ef-layout>
          <input
            className='search-field'
            type="text"
            placeholder="Type to search..."
            onChange={(e) => searchEvent(e.target.value)}
          />
        </ef-layout>
      </ef-layout>
      <ef-layout>
        <efx-grid id="grid" className="entity-grid"></efx-grid>
      </ef-layout>
    </div>
  );
}

function Economics() {
  const [eventTab, setEventTab] = useState("Event_Types");
  const [wealth, setWealth] = useState(false);

  return (
    <div className='main-div'>
      {!(eventTab === "Event_Types" && wealth) && (
        <ef-layout>
          <h4>Economics</h4>
          <ef-button-bar className="data-fields-btn-bar" managed>
            <ef-button toggles active icon="event-marker" onClick={() => setEventTab("Event_Types")}>Event Types</ef-button>
            <ef-button toggles icon="calendar" onClick={() => setEventTab("Events_Calendar")}>Events Calendar</ef-button>
            <ef-button toggles icon="present" onClick={() => setEventTab("Events_Calendar_Premium")}>Events Calendar Premium</ef-button>
          </ef-button-bar>
        </ef-layout>
      )}
      { eventTab === "Event_Types" && (
        <EventTypes wealth={wealth} setWealth={setWealth} />
      )}
      { eventTab === "Events_Calendar" && (
        <EventsCalendar />
      )}
      { eventTab === "Events_Calendar_Premium" && (
        <EventsCalendar flag={false} />
      )}
    </div>
  );
}

export default Economics;